export default {
  BASE_URL: '',
  TOKEN: '',
  FILTER: '',
  HOST: '',
  SINGLE: '',
  ENCHOST: '',
  init: function (token, filter, host, single, encHost) {
    this.BASE_URL = 'https://api.spareparts.live/v1/'
    this.TOKEN = token
    this.FILTER = filter
    this.HOST = host
    this.SINGLE = single
    this.ENCHOST = encHost
  },
  callApi: async function (endpoint, authenticated, method, requestObject, paramType = 'JSON', resultType = 'JSON') {
    let token = localStorage.getItem('parts_id_token') || this.TOKEN;
    let body;
    if (paramType === 'JSON') {
      body = (method === 'POST' || method === 'PUT') ? JSON.stringify(requestObject) : undefined;
    } else {
      const formData = new FormData();
      for (let key in requestObject) 
        formData.append(key, requestObject[key]);
      body = formData;
    }
    let config = {
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      },
      mode: 'no-cors',
      method: method,
      body: body
    }
    let accessToken = '';
    if (authenticated && token) {
      config = {
        method: method,
        body: body
      }
      accessToken = (endpoint.toString().indexOf('?') === -1 ? '?' : '&') + 'token=' + token
    }

    let response = null;

    try {
      response = await fetch(this.BASE_URL + endpoint + accessToken, config);
    } catch (err) {
      throw new Error('Error while doing request');
    }
    let respObj = null;

    if (resultType === 'JSON') {
      try {
        if (response.status !== 204) {
          respObj = await response.json();
        }
      } catch ({ name, message }) {
        // eslint-disable-next-line no-console
        console.log("Error deserializing json from request endpoint " + endpoint + ". Type : " + name + " / Message : " + message);
      }
    } else {
      respObj = await response.text();
    }

    if (!response.ok) {
      if (respObj.error.message !== undefined) {
        throw new Error(respObj.error.message);
      } else {
        throw new Error(respObj.toString());
      }
    }

    return respObj;
  },
  search: async function (term, localeStr, userScope) {
    let param = { term: term, host: this.HOST, enchost: this.ENCHOST };
    if(localeStr != "")
      param.lang = localeStr;

    let scope = parseInt(sessionStorage.getItem('scope') || "-1");
    if (scope != -1 || userScope != -1)
      param.scope = userScope == -1 ? scope : userScope;
    return this.callApi('simpleSearch.php', true, 'POST', param, 'FORM', 'JSON')
  },
  getFeatures: async function () {
    return this.callApi('getFeatures.php', true, 'POST', {});
  },
  getLocales: async function () {
    return this.callApi('getLocales.php', true, 'POST', {})
  },
  // authenticate: async function () {
  // return this.callApi('authenticate.php', true, 'GET',
  //      {})
  // },
  getPubTree: async function (lang) {
    let param = {
      token: this.TOKEN,
      lang: lang,
      filter: this.FILTER,
      host: this.HOST,
      enchost: this.ENCHOST
    };
    let metaData = JSON.parse(sessionStorage.getItem("metadata") || "[]");
    for (const [key, value] of Object.entries(metaData))
      param["meta-" + key] = value;
    if (this.SINGLE && this.SINGLE != '') param.single = this.SINGLE;
    let scope = parseInt(sessionStorage.getItem('scope') || "-1");
    if (scope != -1) param.scope = scope;
    return this.callApi('getPubTree.php', true, 'POST', param);
  },
  getDrawingTreeByPartIdOrProjectId: async function (lang, pubId, projectId) {
    let param = { token: this.TOKEN, lang: lang, pubid: pubId, projectid: projectId };
    return this.callApi('getDrawingTree.php', true, 'POST', param);
  },
  getDrawingTreeByDrawingId: async function (lang, drawingId) {
    let param = { token: this.TOKEN, lang: lang, drawingid: drawingId };
    return this.callApi('getDrawingTree.php', true, 'POST', param);
  },
  getDrawingTreeByDrawingName: async function (lang, drawingName, caseSens, fuzzy) {
    let param = { token: this.TOKEN, lang: lang, drawingname: drawingName, casesens: caseSens, fuzzy: fuzzy };
    return this.callApi('getDrawingTree.php', true, 'POST', param);
  },
  getDrawing: async function (id) {
    return this.callApi('getDrawing.php', true, 'POST',
      { token: this.TOKEN, id: id, host: this.HOST, layer: 'true', type: 'jpg', apipath: this.BASE_URL }, 'JSON', 'text')
  },
  getHotspots: async function (id, lang) {
    let param = { token: this.TOKEN, id: id, lang: lang };
    let scope = parseInt(sessionStorage.getItem('scope') || "-1");
    if (scope != -1) param.scope = scope;
    return this.callApi('getHotspots.php', true, 'POST', param);
  },
  getUXD: async function (lang) {
    return this.callApi('getMeta.php', true, 'POST',
      { token: this.TOKEN, item: 'uxd', lang: lang, width: document.body.scrollWidth })
  },
  registerOrderClick: async function (oem) {
    return this.callApi('register.php', true, 'POST',
      { token: this.TOKEN, host: this.HOST, task: 'orderclick', oem: oem })
  },
  registerQuoteClick: async function (oem) {
    return this.callApi('register.php', true, 'POST',
      { token: this.TOKEN, host: this.HOST, task: 'quoteclick', oem: oem })
  },
  printDrawingAPI: async function (id, lang) {
    return this.callApi('createpdf.php', true, 'POST',
      { token: this.TOKEN, host: this.HOST, drawing: id, language: lang })
  }
}
